import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createSupplyBillsDocument = async (details) => {
    // get the reference to the Firestore document
    const batch = db.batch();
    const uniqueId = uuidv4();
    const docRef = db.collection('SupplyBills').doc();

    //create user object
    details.uniqueId = uniqueId;
    details.SupplyBillsPostedDateTime = new Date();

    // write to Cloud Firestore
    const collectionRef = await db.collection('SupplyBills').doc();
    batch.set(collectionRef, details);
    batch.commit().then(() => {
        return true;
    }).catch((error)=> {
        return false
    });
}

export const getSupplyBillsDocumentCount = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyBills').get();
    return snapshot.docs.length;
}

export const getAllSupplyOrderDocumentForExcel = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyBills').get()
    return snapshot.docs.map(doc => ({...doc.data().ProductEntry, _id: doc.id}));
}

export const getAllSupplyOrderDocumentForExcelInvoice = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyBills').get();
    
    return snapshot.docs.flatMap(doc => {
        const productEntries = doc.data().ProductEntry || [];
        
        return productEntries.map(product => ({
            _id: product._id || uuidv4(),
            ProductName: product.ProductName,
            ProductScheme: product.ProductScheme,
            PackagingSize: product.PackagingSize
        }));
    });
};

export const getSupplyBillsDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyBills').where("userId","==", userId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getSupplyBillsDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyBills').where("uniqueId", "==", uniqueId).get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const getSupplyBillsDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let product = null;
    let retailer = null;
    const productSnapshot = await db.collection('SupplyBills').where("uniqueId", "==", uniqueId).get()
    productSnapshot.docs.map(doc => {
        product = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("uid", "==", product.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        product: product,
        retailer: retailer
    }
}

export const getAllSupplyBillsDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('SupplyBills').get()
    return snapshot.docs.map(doc => ({...doc.data(), _id: doc.id}));
}

export const updateSupplyBillsDocument = async (product) => {
    const docRef = db.doc(`/SupplyBills/${product._id}`);
    return docRef.update(product);
}